import { RouterProvider } from 'react-router-dom';
import { router } from './routes/route';
import { AuthProvider } from './auth/Authprovider';


export default function App() {
  return (
    <>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </>
  )

}